// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.color-swatch[data-v-28d86c50] {\n  border-radius: 6px;\n  height: 40px;\n  outline: solid 1px #d2ddec;\n  width: 40px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
